import React, { useState } from 'react';
import LoadDetail from '../LoadProfile/LoadDetail';

import GET_LOAD_DETAIL from '../../graphql/client/queries/getLoadDetail';
import {
    GetLoadDetail_getLoadDetail as LoadDetailData,
    GetLoadDetail,
    GetLoadProgress,
    GetLoadProgress_getLoadProgress as LoadProgressData,
    GetWellheadsByStageGroupId_getWellheadsByStageGroupId as StageDetails,
    GetBoxes_getBoxes_boxDetails as BoxDetails,
    GetEmptyBoxes_getEmptyBoxes_emptyBoxDetails as EmptyBoxes,
} from '../../types/schemaTypes';
import { useQuery } from '@apollo/client/react';
import { Query } from '../_common';
import { Error, Loading } from '../_common';
import './LoadFieldOp.scss';
import { LoadStatusEnum } from '../../types/LoadStatusEnum';
import { DriverLoadStatusEnum } from '../../types/DriverLoadStatusEnum';
import { Option } from '../Users/interface';
import { useAuthContext } from '../Auth/AuthProvider';
import { PermissionEnum } from '../../types/PermissionEnum';
import LoadFieldOpDetail from './LoadFieldOpDetail';
import { GET_LOAD_PROGRESS } from '../../graphql/client/queries';
import UploadLoadImage from '../LoadProfile/LoadProgress/LoadImage/UploadLoadImage';
import { Routes } from '../../utils/Routes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams,Link } from 'react-router-dom';

const LoadFieldOp = ({ match }: any): React.ReactElement => {
    const [showModal, setShowModal] = useState(false);

    const {loadId} = useParams()
    const loadIdVal:any = loadId
    
    const onCancel = (): void => {
        window.history.back();
    };

    const variables = {
        loadId: parseInt(loadIdVal),
    };

    let loadProgressData1: LoadProgressData | null;
    let loadStatusField = '';
    let loadJobId = 0;

    const { data: loadProgressData } = useQuery<GetLoadProgress>(GET_LOAD_PROGRESS, {
        variables: { loadId: variables.loadId },
        fetchPolicy: 'network-only',
    });

    if (loadProgressData?.getLoadProgress) {
        loadProgressData1 = loadProgressData.getLoadProgress;
    }

    const [tabTitle, setTabTitle] = useState(document.title);
    const authContext = useAuthContext();
    const canEditLoadFieldOp = authContext.userHasPermission(PermissionEnum.UpdateLoadFieldOp);

    const openLoadProfile = (loadId: number): void => {
        const URL = `${window.location.origin}${Routes.LOAD_PROFILE.route}`;
        window.open(URL + loadId, '_blank');
    };
    if (canEditLoadFieldOp) {
        return (
            <Query<GetLoadDetail> query={GET_LOAD_DETAIL} variables={variables} fetchPolicy="cache-and-network">
                {({ loading, error, data, refetch }): React.ReactElement | null => {
                    if (loading) {
                        return <Loading />;
                    }

                    if (error) {
                        return <Error error={error} />;
                    }

                    let loadDetailData: LoadDetailData | null;
                    loadStatusField = data?.getLoadDetail?.status ? data.getLoadDetail.status : LoadStatusEnum.CREATED;
                    loadJobId = data?.getLoadDetail?.loadJobId ? data.getLoadDetail.loadJobId : 0;

                    if (data && data.getLoadDetail && data.getLoadDetail.status === LoadStatusEnum.ON_SITE) {
                        if (
                            data.getLoadDetail.isSplit &&
                            !(data.getLoadDetail.secondaryDriverLoadStatus === DriverLoadStatusEnum.ACCEPTED)
                        ) {
                            return (
                                <div style={{ padding: 15 }}>
                                    <span>
                                        Split load is not Assigned to a Secondary Driver/ Accepted by Secondary Driver.
                                        Please go to load details page for more information{''}
                                    </span>
                                    <span
                                        className="Load-Link"
                                        onClick={(): void => openLoadProfile(parseInt(loadIdVal))}
                                    >
                                        {' '}
                                        {parseInt(loadIdVal)}{' '}
                                        <FontAwesomeIcon icon={['fas', 'external-link-alt']} />
                                    </span>
                                </div>
                            );
                        }
                        loadDetailData = data.getLoadDetail as LoadDetailData;
                        loadProgressData1 = loadProgressData?.getLoadProgress ?? null;

                        const sandTicketComponent = loadProgressData1 ? (
                            <UploadLoadImage
                                ticketNumber={loadProgressData1.sandTicketNumber}
                                ticketImage={loadProgressData1.sandTicketImage}
                                ticketUploadedBy={loadProgressData1.sandTicketUploadedBy}
                                imageText="SandTicket #: "
                                ticketUploadedAt={loadProgressData1.sandTicketUploadedAt}
                                ticketName="stn"
                                loadId={loadDetailData!.loadId}
                                loadStatus={loadDetailData!.status}
                                canUploadImage={false}
                            />
                        ) : (
                            <UploadLoadImage canUploadImage={false} />
                        );

                        const loadJobName = loadDetailData && loadDetailData.jobName ? loadDetailData.jobName : '';
                        const loadLoadId =
                            loadDetailData && loadDetailData.loadId ? loadDetailData.loadId.toString() : tabTitle;

                        document.title = loadJobName + ':' + loadLoadId;
                        localStorage.setItem('loadHistory-JobName', loadJobName);
                        setTabTitle(document.title);

                        const loadDetailComponent = loadDetailData ? (
                            <LoadFieldOpDetail
                                loadDetailData={loadDetailData}
                                loadProgressData1={loadProgressData1}
                                sandTicketComponent={sandTicketComponent}
                                jobId={loadDetailData.loadJobId}
                                proppantId={loadDetailData.proppantId}
                            />
                        ) : (
                            <LoadFieldOpDetail
                                loadId={0}
                                tareWeight={0}
                                grossWeight={0}
                                netWeight={0}
                                milesToWell={0}
                            />
                        );

                        const checkForStatus = (): boolean => {
                            if (loadDetailData && loadDetailData.status === LoadStatusEnum.COMPLETED) {
                                setShowModal(false);
                                return true;
                            } else {
                                refetch();
                                setShowModal(true);
                            }
                            return false;
                        };

                        return (
                            <div className="LoadProfile-Container">
                                <div className="LoadProfile-HeaderTitle col-md-1">
                                    {/* <Link
                                        to={{
                                            pathname: `${Routes.JOB_ACTIVITY.route}${data.getLoadDetail.loadJobId}`,
                                        }}
                                        className="StageSheet-Back-Button"
                                    >
                                        Back
                                    </Link> */}
                                </div>
                                <div className="LoadProfile-Header">
                                    <div className="LoadProfile-HeaderTitle">
                                        Load Information #{loadDetailData && loadDetailData.loadId}
                                        {(() => {
                                            if (loadDetailData?.status === LoadStatusEnum.COMPLETED) {
                                                return (
                                                    <div className="LoadProfile-CompleteLabel">
                                                        <i className="material-icons complete-icon-size">
                                                            check_circle_outline
                                                        </i>
                                                        <span className="complete-label">COMPLETED</span>
                                                    </div>
                                                );
                                            } else if (loadDetailData?.status === LoadStatusEnum.CANCELED) {
                                                return (
                                                    <div className="LoadProfile-CompleteLabel">
                                                        <i className="material-icons complete-icon-size">cancel</i>
                                                        <span className="complete-label">CANCELED</span>
                                                    </div>
                                                );
                                            } else {
                                                return <div></div>;
                                            }
                                        })()}
                                    </div>
                                </div>
                                <div>{loadDetailComponent}</div>
                            </div>
                        );
                    } else {
                        return (
                            <div style={{ padding: 15 }}>
                                {/* <Link
                                    to={{
                                        pathname: `${Routes.JOB_ACTIVITY.route}${loadJobId}`,
                                    }}
                                    className="StageSheet-Back-Button col-md-1"
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                >
                                    Back
                                </Link> */}
                                <span>
                                    The Load #{loadIdVal} is in #{loadStatusField} Status. Only Loads with
                                    On-site status will be available here. Please go to load details page for more
                                    information{''}
                                </span>
                                <span
                                    className="Load-Link"
                                    onClick={(): void => openLoadProfile(parseInt(loadIdVal))}
                                >
                                    {' '}
                                    {parseInt(loadIdVal)}{' '}
                                    <FontAwesomeIcon icon={['fas', 'external-link-alt']} />
                                </span>
                            </div>
                        );
                    }
                }}
            </Query>
        );
    } else {
        return (
            <div style={{ padding: 15 }}>
                <span>Access to this page is restricted to your Role. Please go to load details page {''}</span>
                <span className="Load-Link" onClick={(): void => openLoadProfile(parseInt(loadIdVal))}>
                    {' '}
                    {parseInt(loadIdVal)} <FontAwesomeIcon icon={['fas', 'external-link-alt']} />
                </span>
            </div>
        );
    }
};

export default LoadFieldOp;
